function checkCopyTableWidth(table, parent) {
	// Uses this heroes response to get the min table width
	// https://stackoverflow.com/a/55502400/1268546

	const originalWidth = parent.style.width;
	parent.style.width = '1px';
	const smallestWidth = table.getBoundingClientRect().width;
	parent.style.width = originalWidth;

	if (window.innerWidth - 50 <= smallestWidth) {
		parent.classList.add('table-container--edged');
	} else {
		parent.classList.remove('table-container--edged');
	}
}

(function ($, window) {
	'use strict';

	$(function () {
		Array.from(document.querySelectorAll('.copy table')).forEach((table) => {
			const tableParent = document.createElement('div');
			const tableParentNode = table.parentNode;

			tableParent.classList.add('table-container');
			tableParent.appendChild(table);
			tableParentNode.appendChild(tableParent);

			checkCopyTableWidth(table, tableParent);

			window.addEventListener('resize', function () {
				checkCopyTableWidth(table, tableParent)
			});
		});
	});
})(jQuery, window);
